namespace $ {
	/** A bounded public index, not a container for report payloads. */
	export class $shm_hitalama_benchmarks_archive_shard extends $shm_hitalama_benchmarks_catalog_run.with({
		Index: $giper_baza_dict_to($giper_baza_atom_link.to(()=> $shm_hitalama_benchmarks_catalog_run)),
		Deleted: $giper_baza_dict_to($giper_baza_atom_bool),
		Counts: $giper_baza_dict_to($giper_baza_atom_dict),
	}) {}
}
